import { http } from "@/lib/api";

export const COACHING_AUTONOMY_MODES = {
  RECOMMENDATIONS_ONLY: "RECOMMENDATIONS_ONLY",
  SAFE_RECOVERY_AUTO: "SAFE_RECOVERY_AUTO",
};

export const fetchCoachingSettings = async () => {
  const { data } = await http.get("/athlete/coaching-settings");
  return data;
};

export const updateCoachingSettings = async (coachingAutonomyMode) => {
  const { data } = await http.patch("/athlete/coaching-settings", {
    coaching_autonomy_mode: coachingAutonomyMode,
  });
  return data;
};
